export enum MuExceptionCode {
  COMMON = 1,
}
